// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux Form
import { Field, reduxForm } from 'redux-form';

// Redux
import { connect } from 'react-redux';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import {
    Grid,
    Button,
    Row,
    Col,
} from 'react-bootstrap';
import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

import update from './update';
import history from '../../core/history';

// Component
import Avatar from '../Avatar';

// Images
import BgImage from '../../../public/SiteImages/createListBg.svg';
import ListImage from '../../../public/SiteImages/createListImage.svg';
import darkImage from '../../../public/SiteImages/darkIntro.svg';
import waveIcon from '../../../public/SiteIcons/waving-hand.png';


class ListIntro extends Component {

    static propTypes = {
        initialValues: PropTypes.object,
        hostDisplayName: PropTypes.string.isRequired,
        guestDisplayName: PropTypes.string,
        nextPage: PropTypes.any,
        hostPicture: PropTypes.string,
        guestPicture: PropTypes.string,
        userData: PropTypes.shape({
            firstName: PropTypes.string.isRequired
        }).isRequired
    };

    static defaultProps = {
        userData: {
            firstName: ''
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            roomType: [],
            personCapacity: [],
            listingType: 'accommodation'
        }
        this.selectListingType = this.selectListingType.bind(this);
    }

    selectListingType(listingType) {
        const { change, nextPage } = this.props;
        if (listingType === 'experience') {
            history.push('/become-a-host/experience');
            return;
        }
        change('listingType', listingType);
        this.setState({ listingType }, () => nextPage('room'));
    }

    UNSAFE_componentWillMount() {
        const { listingFields } = this.props;
        if (listingFields != undefined) {
            this.setState({
                roomType: listingFields.roomType,
                personCapacity: listingFields.personCapacity
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { listingFields } = nextProps;
        if (listingFields != undefined) {
            this.setState({
                roomType: listingFields.roomType,
                personCapacity: listingFields.personCapacity
            });
        }
    }


    render() {
        const { userData, hostPicture, hostDisplayName, guestDisplayName } = this.props;
        return (
            <div className={s.listIntroBgSection}>
                <div className={cx(s.listIntroBg, 'listIntroBgImage')} style={{ backgroundImage: `url(${BgImage})` }} ></div>
                <Grid fluid className={s.listIntroContainer}>
                    <div className={s.userRight}>
                        <Avatar
                            isUser
                            title={guestDisplayName}
                            className={s.profileImage}
                        />
                    </div>
                    <h3 className={s.listIntroTitle}><img src={waveIcon} className={s.waveCss} /> <FormattedMessage {...messages.hi} />,<span className={s.userNameColor}>{userData.firstName}!</span></h3>
                    <h3 className={cx(s.listIntroTitle, s.spaceTop4, s.spaceBottom20)}>¿Qué quieres publicar?</h3>
                    <div className={s.listingTypeChoices}>
                        <Button className={cx(s.listingTypeChoice, bt.btnPrimary)} onClick={() => this.selectListingType('accommodation')}>
                            <strong>Hospedaje rural</strong><span>Finca, cabaña, glamping u hotel rural</span>
                        </Button>
                        <Button className={cx(s.listingTypeChoice, bt.btnPrimary)} onClick={() => this.selectListingType('experience')}>
                            <strong>Experiencia rural</strong><span>Gastronomía, aventura, bienestar o celebración</span>
                        </Button>
                    </div>
                    <img className={cx(s.userDescriptionImage, 'lightModeImg')} src={ListImage} />
                    <img className={cx(s.userDescriptionImage, 'darkModeImg')} src={darkImage} />

                </Grid>
            </div>
        )
    }
}

ListIntro = reduxForm({
    form: 'ListPlaceStep1', // a unique name for this form
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    onSubmit: update
})(ListIntro);

const mapState = (state) => ({
    userData: state.account.data,
    listingFields: state.listingFields.data
});

const mapDispatch = {
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(ListIntro)));
